import { NgModule } from '@angular/core';
import { BalanceComponent } from './balance.component';
import { CommonModule } from '@angular/common';
import { UIModule } from '../../ui/ui.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    BalanceComponent,
  ],
  exports: [
    BalanceComponent
  ],
    imports: [
        CommonModule,
        UIModule,
        NzToolTipModule,
        RouterModule,
    ],
})
export class BalanceModule { }
